/** 解析接口返回的 couponExpireTime（毫秒时间戳，可能为 string） */
export function parseCouponExpireTimeMs(raw) {
  if (!raw || typeof raw !== "object") return null;
  const v = raw.couponExpireTime ?? raw.coupon_expire_time;
  if (v === undefined || v === null || v === "") return null;
  const ts = Number(v);
  if (!Number.isFinite(ts) || ts <= 0) return null;
  return ts;
}

/** 是否体验金/体验券持仓（跟单列表角标与到期时间展示） */
export function isAicopyCouponPosition(raw) {
  if (!raw || typeof raw !== "object") return false;
  const v = raw.couponPosition ?? raw.coupon_position;
  return v === true || v === "true" || v === 1 || v === "1";
}

/**
 * 券到期倒计时展示（剩余毫秒 → 文案）
 * @returns {{ text: string, expired: boolean }}
 */
export function formatCouponExpireCountdown(remainingMs) {
  const ms = Number(remainingMs);
  if (!Number.isFinite(ms) || ms <= 0) {
    return { text: "00:00:00", expired: true };
  }
  const totalSec = Math.floor(ms / 1000);
  const days = Math.floor(totalSec / 86400);
  const hours = Math.floor((totalSec % 86400) / 3600);
  const minutes = Math.floor((totalSec % 3600) / 60);
  const seconds = totalSec % 60;
  const pad = (n) => String(n).padStart(2, "0");
  if (days > 0) {
    return { text: `${days}d ${pad(hours)}:${pad(minutes)}:${pad(seconds)}`, expired: false };
  }
  return { text: `${pad(hours)}:${pad(minutes)}:${pad(seconds)}`, expired: false };
}

/** 解析 startTime / 通用毫秒时间戳 */
export function parseAicopyTimestampMs(v) {
  if (v === undefined || v === null || v === "") return null;
  const ts = Number(v);
  if (!Number.isFinite(ts) || ts <= 0) return null;
  return ts;
}

/** 跟随开始时间展示：YYYY/MM/DD HH:mm:ss */
export function formatAicopyFollowStartTime(timestampMs) {
  const ts = parseAicopyTimestampMs(timestampMs);
  if (ts == null) return "";
  const date = new Date(ts);
  if (Number.isNaN(date.getTime())) return "";
  const pad = (n) => String(n).padStart(2, "0");
  return `${date.getFullYear()}/${pad(date.getMonth() + 1)}/${pad(date.getDate())} ${pad(date.getHours())}:${pad(
    date.getMinutes()
  )}:${pad(date.getSeconds())}`;
}

/**
 * 当前跟单：已跟随时长 / 到期剩余 — xD:HH:MM（天带 D 后缀，避免与时分秒混淆）
 * @param {number} ms 毫秒（已跟随时长或剩余时长）
 */
export function formatAicopyDdHhMmCountdown(ms) {
  const totalMs = Math.max(0, Number(ms) || 0);
  const totalSec = Math.floor(totalMs / 1000);
  const days = Math.floor(totalSec / 86400);
  const hours = Math.floor((totalSec % 86400) / 3600);
  const minutes = Math.floor((totalSec % 3600) / 60);
  const pad = (n) => String(n).padStart(2, "0");
  return `${days}D:${pad(hours)}:${pad(minutes)}`;
}

/** 展示用：YYYY/MM/DD HH:mm:ss（历史跟单等静态展示） */
export function formatAicopyCouponExpireDateTime(timestampMs) {
  if (timestampMs == null) return "";
  const ts = Number(timestampMs);
  if (!Number.isFinite(ts) || ts <= 0) return "";
  const date = new Date(ts);
  if (Number.isNaN(date.getTime())) return "";
  const pad = (n) => String(n).padStart(2, "0");
  return `${date.getFullYear()}/${pad(date.getMonth() + 1)}/${pad(date.getDate())} ${pad(date.getHours())}:${pad(
    date.getMinutes()
  )}:${pad(date.getSeconds())}`;
}
